import { Box, Grid, Button, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import { useIssueActivationToken } from 'hooks/devices/useIssueToken';
import QRCode from 'react-qr-code';
import { useMe } from 'hooks/useMe';
import ImageCrop from './ImageCrop';
import { devices } from 'apis';
import { useSignalRConnection } from 'hooks/hubs/useSignalRConnection';
import { ActionType } from 'enums/actionType';
import { v4 as uuidv4 } from 'uuid';
import { store } from 'store';

const MobileUploadTab = forwardRef((props, ref) => {
    const { onUpload, displayedData, setDisplayedData } = props;
    const { t } = useTranslation();
    const whoami = useMe();
    const cropperRef = useRef(null);
    const [showQr, setShowQr] = useState(false);
    const { token, setUserId, triggerRefetch } = useIssueActivationToken();
    const [image, setImage] = useState(null);
    const [cropCompelted, setCropCompleted] = useState(false);
    const state = store.getState();
    // const [displayedData, setDisplayedData] = useState([]);

    // this is pointless to do this way
    useEffect(() => {
        setUserId(whoami?.whoami?.userId);
    }, [whoami]);

    useSignalRConnection({
        onDataReceived: (data) => {
            setDisplayedData((prev) => [...prev, JSON.parse(data)]);
        }
    });

    // on load, set the image to the image index
    // when the image index changes, set the image to the image index
    // when signalr receives data, set the image to the last item in the array

    useEffect(() => {
        if (displayedData.length > 0) {
            const actionResponse = displayedData[displayedData.length - 1];
            const formattedResponse = { ...actionResponse };
            delete formattedResponse.data;
            setImage(actionResponse.data);
        }
    }, [displayedData]);

    const handleCaptureImage = async () => {
        const result = await devices
            .requestAction({
                actionId: uuidv4().toString(),
                userId: whoami?.whoami?.userId,
                accessToken: state.auth.accessToken,
                actionType: ActionType.captureImage,
                payload: {}
            })
            .catch((err) => console.log(err));
    };

    const handleUpload = (file) => {
        if (onUpload && typeof onUpload === 'function') onUpload([file]);
    };

    /* const handleShowQr = () => {
        setShowQr((prev) => !prev);
    }; */

    useImperativeHandle(ref, () => ({
        handleShowQr() {
            setShowQr((prev) => !prev);
        },
        async handleRequestImage() {
            await devices
                .requestAction({
                    actionId: uuidv4().toString(),
                    userId: whoami?.whoami?.userId,
                    accessToken: state.auth.accessToken,
                    actionType: ActionType.captureImage,
                    payload: {}
                })
                .catch((err) => console.log(err));
        },
        cropperRef
    }));

    return (
        <Box
            sx={{
                display: 'flex',
                borderWidth: '3px',
                borderStyle: 'dashed',
                borderRadius: 4,
                flexGrow: 1,
                height: 'inherit',
                m: 1
            }}
            justifyContent="center"
            alignItems="center"
        >
            <Box hidden={showQr || !displayedData.length > 0}>
                <ImageCrop
                    src={`data:image/png;base64,${image}`}
                    aspect={16 / 9}
                    savePhoto={handleUpload}
                    ref={cropperRef}
                    setCompleted={setCropCompleted}
                />
            </Box>
            <Box hidden={!showQr}>
                <Stack spacing={2} alignItems="center" justifyContent="flex-start">
                    <Box>
                        <QRCode size={256} value={token ?? ''} viewBox="0 0 256 256" />
                    </Box>
                    <Button
                        onClick={triggerRefetch}
                        variant="outlined"
                        sx={{
                            color: '#4d79bc',
                            borderColor: '#4d79bc',
                            ':hover': { color: '#fff', background: '#4d79bc', borderColor: '#fff' }
                        }}
                    >
                        {t('RequestNewQR')}
                    </Button>
                </Stack>
            </Box>
            {/* <Grid
                    item
                    container
                    spacing={1}
                    sx={{ height: '5vh', borderRadius: 4 }}
                    alignItems="center"
                    justifyContent="center"
                    xs={12}
                >
                    <Grid item xs={3}>
                        <Button
                            variant="contained"
                            onClick={handleShowQr}
                            sx={{
                                width: '100%',
                                background: '#4d79bc',
                                ':hover': { background: '#79AEC9', color: '#fff' }
                            }}
                        >
                            {showQr ? t('Back') : t('PairDevice')}
                        </Button>
                    </Grid>
                    <Grid item xs={3}>
                        <Button
                            variant="contained"
                            disabled={showQr}
                            onClick={handleCaptureImage}
                            sx={{
                                width: '100%',
                                background: '#4d79bc',
                                ':hover': { background: '#79AEC9', color: '#fff' }
                            }}
                        >
                            {t('CaptureImage')}
                        </Button>
                    </Grid>
                    <Grid item xs={3}>
                        <Button
                            variant="contained"
                            disabled={showQr || !cropCompelted}
                            sx={{
                                width: '100%',
                                background: '#4d79bc',
                                ':hover': { background: '#79AEC9', color: '#fff' }
                            }}
                            onClick={() => cropperRef.current?.handleSavePhoto()}
                        >
                            {t('SaveImage')}
                        </Button>
                    </Grid>
                </Grid> */}
        </Box>
    );
});

export default MobileUploadTab;
